export default "__VITE_ASSET__BjKyUyN3__"